import React, { useState } from 'react';
import { Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import { CoreBadge } from '../../../RnRCommonComponent';
import './style.scss';
import uuid from 'uuid/v4';
import ViewRewardModal from '../../../RnRCommonComponent/ViewRewardModal/ViewRewardModal.jsx';
import { MAPPED_BADGE_TYPE } from '../../../RnRCommonComponent/CoreBadge/rewardsConstants.js';
import NoDataState from '../../../RnRCommonComponent/noDataState/NoDataState.jsx';
import { addCommas } from '../../../rewardsAndRecognitionHelper/utils.js';

const RewardDashboard = (props) => {
	const {
		rewardsListData: unfilteredRewardsListData,
		rewardModalData: unmappedRewardModalData = {},
		getRewardDetail,
		isLoading,
		isSharingVisible,
		currentUser,
	} = props;
	let history = useHistory();
	const [isModelOpen, setIsModelOpen] = useState(false);
	const rewardsListData = unfilteredRewardsListData.filter(
		(reward) => reward?.rawAssignment?.badge
	);

	const confirmBadgeType = () => {
		if (
			rewardsListData[0]?.badgeTypeCode === MAPPED_BADGE_TYPE.AUTOMATED ||
			rewardsListData[1]?.badgeTypeCode === MAPPED_BADGE_TYPE.AUTOMATED
		) {
			return false;
		}
		return true;
	};

	const rewardModalData = {
		...unmappedRewardModalData.rawAssignment,
		badgeType: unmappedRewardModalData.badgeType,
		iconInfo: unmappedRewardModalData.iconInfo,
		label: unmappedRewardModalData.label,
		color: unmappedRewardModalData.color,
		gradientColor: unmappedRewardModalData.gradientColor,
		shape: unmappedRewardModalData.shape,
		badgeRotation: unmappedRewardModalData.badgeRotation,
		customImageSignedUrl: unmappedRewardModalData.customImageSignedUrl,
		labelColor: unmappedRewardModalData.labelColor,
		customIconSignedUrl: unmappedRewardModalData.customIconSignedUrl,
	};

	return (
		<div className="reward-card d-card">
			<div className="d-flex align-items-center justify-content-between">
				<h4 className="reward-card-title">My Recognitions</h4>
				{(confirmBadgeType && rewardsListData?.length > 0) ||
				rewardsListData?.length > 2 ? (
					<div
						className="reward-card-view-all"
						onClick={() => {
							history.push('/my-recognitions');
						}}
					>
						View All
					</div>
				) : (
					<></>
				)}
			</div>

			{isLoading ? (
				<div
					style={{
						minHeight: 164,
						display: 'flex',
						alignItems: 'center',
					}}
				>
					<Spin className="d-flex align-items-center justify-content-center w-100 h-100" />
				</div>
			) : rewardsListData?.length > 0 ? (
				<>
					{confirmBadgeType() ? (
						<>
							<div className="pt-4 your-rewards your-rewards-list">
								{rewardsListData?.slice(0, 2).map((badge) => {
									const hasSnappyId =
										badge?.snappyGrantId || badge?.snappyGrant?.id;
									const isManagerOrAdmin = [
										'manager',
										'admin',
										'superadmin',
									].includes(currentUser?.role?.toLowerCase());
									const hideSnappyIcon = !(hasSnappyId && isManagerOrAdmin);
									const currencySymbol =
										badge?.snappyGrant?.currencySymbol || '$';

									const snappyDetails = hasSnappyId
										? {
												snappyGrantId:
													badge?.snappyGrantId || badge?.snappyGrant?.id,
												snappyGrantName:
													badge?.snappyGrant?.name || 'Snappy Reward',
												costInCurrency: `${currencySymbol}${badge?.snappyGrant?.costInCurrency || '0'}`,
												description:
													badge?.snappyGrant?.description ||
													'Snappy Gift Attached ⭐️',
											}
										: {};

									return (
										<div
											onClick={() => {
												getRewardDetail(badge);
												setIsModelOpen(true);
											}}
											className="text-center home-my-reward single-reward"
											key={badge?.badgeId + uuid()}
										>
											{badge.badgeId != null ? (
												<>
													<CoreBadge
														badgeType={badge?.badgeTypeCode}
														badgeIcon={badge?.iconCode}
														label={badge?.label}
														color={badge?.color}
														gradientColor={badge?.gradientColor}
														shape={badge?.shape}
														badgeRotation={badge?.badgeRotation}
														customImageSignedUrl={badge?.customImageSignedUrl}
														labelColor={badge?.labelColor}
														customIconSignedUrl={badge?.customIconSignedUrl}
														hideSnappyIcon={hideSnappyIcon}
														snappyDetails={snappyDetails}
													/>
													{badge?.points && (
														<div className="reward-card-points">
															{addCommas(badge?.points)} Points
														</div>
													)}
												</>
											) : (
												<></>
											)}
										</div>
									);
								})}
							</div>
						</>
					) : (
						<>
							<div className="pt-4 your-rewards your-rewards-list">
								{(() => {
									const badge = rewardsListData[0];
									const hasSnappyId =
										badge?.snappyGrantId || badge?.snappyGrant?.id;
									const isManagerOrAdmin = [
										'manager',
										'admin',
										'superadmin',
									].includes(currentUser?.role?.toLowerCase());
									const hideSnappyIcon = !(hasSnappyId && isManagerOrAdmin);
									const currencySymbol =
										badge?.snappyGrant?.currencySymbol || '$';

									const snappyDetails = hasSnappyId
										? {
												snappyGrantId:
													badge?.snappyGrantId || badge?.snappyGrant?.id,
												snappyGrantName:
													badge?.snappyGrant?.name || 'Snappy Reward',
												costInCurrency: `${currencySymbol}${badge?.snappyGrant?.costInCurrency || '0'}`,
												description:
													badge?.snappyGrant?.description ||
													'Snappy Gift Attached ⭐️',
											}
										: {};

									return (
										<div
											onClick={() => {
												getRewardDetail(rewardsListData[0]);
												setIsModelOpen(true);
											}}
											className="text-center home-my-reward"
											key={rewardsListData[0]?.badgeId}
										>
											{rewardsListData[0].badgeId != null ? (
												<>
													<CoreBadge
														badgeType={rewardsListData[0]?.badgeTypeCode}
														badgeIcon={rewardsListData[0]?.iconCode}
														label={rewardsListData[0]?.label}
														color={rewardsListData[0]?.color}
														gradientColor={rewardsListData[0]?.gradientColor}
														shape={rewardsListData[0]?.shape}
														badgeRotation={rewardsListData[0]?.badgeRotation}
														customImageSignedUrl={rewardsListData[0]?.customImageSignedUrl}
														labelColor={rewardsListData[0]?.labelColor}
														customIconSignedUrl={rewardsListData[0]?.customIconSignedUrl}
														hideSnappyIcon={hideSnappyIcon}
														snappyDetails={snappyDetails}
													/>
													<div className="reward-card-points">
														{rewardsListData[0]?.points} Points
													</div>
													{rewardsListData[0]?.rewardBonus ? (
														<div className="reward-card-bonus">
															${rewardsListData[0]?.rewardBonus} bonus
														</div>
													) : null}
												</>
											) : (
												<></>
											)}
										</div>
									);
								})()}
							</div>
						</>
					)}
				</>
			) : (
				<NoDataState title={"You haven't received an award yet"} />
			)}
			<ViewRewardModal
				isViewRewardModalVisible={isModelOpen}
				handleCloseViewReward={() => setIsModelOpen(false)}
				rewardDetails={rewardModalData}
				isModalLoaderVisible={false}
				isSharingVisible={isSharingVisible}
				isBadgeAssignment={true}
			/>
		</div>
	);
};

export default RewardDashboard;
